function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 5c5.523 0 10 4.477 10 10s-4.477 10-10 10S5 20.523 5 15 9.477 5 15 5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15 7a8 8 0 100 16 8 8 0 000-16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16v2h-2v-2h2zm8 0v2h-6v-2h6zm-8-4v2h-2v-2h2zm8 0v2h-6v-2h6z"
});

function SvgQMcNonscoredTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQMcNonscoredTypeIcon;